import React from "react";
import voxAppicon from "../Assets/images/VoxApp-Icon.png";

export const SignInBanner = () => {
  return (
    <div className="signup__item signup__item--bg">
      <div className="welcomeInfo">
        <div className="welcomeInfo__header">
          <h1 className="title title--h1">
            Smarter Conversations, Better Business
          </h1>
        </div>
        <div className="branding">
          <div className="branding__logo">
            <img
              src={voxAppicon}
              alt="Logo | Vox App"
              className="branding__logo__img"
            />
          </div>
          <div className="branding__info">
            {/* <h2 className="title title--h1">Search</h2> */}
            {/* <p className="text">Make your efforts accurate with VoxApp</p> */}
            <p className="text">
              Transform conversations into outcomes with VoxApp, the AI voice
              assistant designed to streamline operations, enhance customer
              experiences, and scale your business
            </p>
          </div>
          {/* <div className="form__groupField">
            <input
              type="text"
              id="search"
              className="form__input"
              placeholder="What are you looking for?"
            />
            <button className="btn">
              <svg
                width="13"
                height="18"
                viewBox="0 0 13 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.25 12.5C7.24424 12.499 8.19747 12.1035 8.90051 11.4005C9.60355 10.6975 9.99897 9.74424 10 8.75V3.75C10 2.75544 9.60491 1.80161 8.90165 1.09835C8.19839 0.395088 7.24456 0 6.25 0C5.25544 0 4.30161 0.395088 3.59835 1.09835C2.89509 1.80161 2.5 2.75544 2.5 3.75V8.75C2.50103 9.74424 2.89645 10.6975 3.59949 11.4005C4.30253 12.1035 5.25576 12.499 6.25 12.5ZM3.75 3.75C3.75 3.08696 4.01339 2.45107 4.48223 1.98223C4.95107 1.51339 5.58696 1.25 6.25 1.25C6.91304 1.25 7.54893 1.51339 8.01777 1.98223C8.48661 2.45107 8.75 3.08696 8.75 3.75V8.75C8.75 9.41304 8.48661 10.0489 8.01777 10.5178C7.54893 10.9866 6.91304 11.25 6.25 11.25C5.58696 11.25 4.95107 10.9866 4.48223 10.5178C4.01339 10.0489 3.75 9.41304 3.75 8.75V3.75ZM6.875 14.9688V16.875C6.875 17.0408 6.80915 17.1997 6.69194 17.3169C6.57473 17.4342 6.41576 17.5 6.25 17.5C6.08424 17.5 5.92527 17.4342 5.80806 17.3169C5.69085 17.1997 5.625 17.0408 5.625 16.875V14.9688C4.0841 14.812 2.65607 14.0893 1.61707 12.9407C0.578064 11.792 0.00190321 10.2989 0 8.75C0 8.58424 0.0658481 8.42527 0.183058 8.30806C0.300269 8.19085 0.45924 8.125 0.625 8.125C0.79076 8.125 0.949731 8.19085 1.06694 8.30806C1.18415 8.42527 1.25 8.58424 1.25 8.75C1.25 10.0761 1.77678 11.3479 2.71447 12.2855C3.65215 13.2232 4.92392 13.75 6.25 13.75C7.57608 13.75 8.84785 13.2232 9.78553 12.2855C10.7232 11.3479 11.25 10.0761 11.25 8.75C11.25 8.58424 11.3158 8.42527 11.4331 8.30806C11.5503 8.19085 11.7092 8.125 11.875 8.125C12.0408 8.125 12.1997 8.19085 12.3169 8.30806C12.4342 8.42527 12.5 8.58424 12.5 8.75C12.4981 10.2989 11.9219 11.792 10.8829 12.9407C9.84393 14.0893 8.4159 14.812 6.875 14.9688Z"
                  fill="#1C1C1C"
                  fill-opacity="0.28"
                />
              </svg>
            </button>
          </div> */}
        </div>
        {/* <div className="welcomeInfo__footer">
          <p>
            Transform conversations into outcomes with VoxApp, the AI voice
            assistant designed to streamline operations, enhance customer
            experiences, and scale your business
          </p>
        </div> */}
      </div>
    </div>
  );
};
